<template>
  <div class="convert-contents-result">
    <div class="table-wrap">
      <table class="table">
        <thead>
          <tr>
            <th>サイト名</th>
            <th>次回送信時刻</th>
            <th>送信開始時間</th>
            <th>送信終了時間</th>
            <th style="width: 100px;">最新送信結果</th>
            <th style="width: 100px;">送信結果履歴</th>
          </tr>
        </thead>
        <tr v-if="result && Object.keys(result).length === 0">
          <td colspan="6">
            <div class="no_data">
              コンバート送信履歴がありません。
            </div>
          </td>
        </tr>
        <tr v-for="(data, dataIdx) in result" :key="dataIdx">
          <td>{{ data.portal_site_name }}</td>
          <td>{{ data.next_conv_time }}</td>
          <td>{{ data.started_at_date }}</td>
          <td>{{ data.ended_at_date }}</td>
          <td>
            <i-button type="primary" size="small" @click="onClickDetail(data.convert_result_id)">詳細</i-button>
          </td>
          <td>
            <i-button type="primary" size="small" @click="onClickHistory(data.portal_site_cd)">履歴</i-button>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import { Button } from 'view-design'
export default {
  components: {
    'i-button': Button,
  },
  data() {
    return {}
  },
  computed: {
    result: {
      get() {
        return this.$store.getters['ConvertSummary/getResult']
      },
      set(val) {
        this.$store.commit('ConvertSummary/setResult', val)
      },
    },
    shopId() {
      return this.$store.getters['ConvertSummary/getShopId']
    },
  },
  methods: {
    // コンバート詳細ボタン
    async onClickDetail(resultId) {
      const params = { resultId: resultId }
      this.$store.dispatch('ModalConvertDetail/set', params)
    },
    // コンバート履歴ボタン
    async onClickHistory(portalSiteCd) {
      const params = {
        portalSiteCd: portalSiteCd,
        shopId: this.shopId,
      }
      this.$store.dispatch('ModalConvertHistory/set', params)
    },
  },
}
</script>

<style lang="scss" scoped>
.convert-contents-result {
  .table-wrap {
    width: 100%;
  }
  .table {
    width: 800px;
    border-collapse: collapse;
    table-layout: fixed;
    margin-bottom: 0;
    th,
    td {
      padding: 4px 0;
      border: 1px solid #cfcfcf;
      text-align: center;
    }
    th {
      background-color: #f0f0f0;
    }
  }
  .no_data {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 16px;
  }
}
</style>
